export const SWITCH_MENU = 'SWITCH_MENU';
